"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHifiLandingView = void 0;
/**
 * A builder for HifiLandingView
 *
 * @param data - The event data
 * @return The formatted event data for HifiLandingViewEvent
 */
function createHifiLandingView(data) {
    return {
        name: 'HifiLandingView',
        environments: ['browser'],
        data: data,
    };
}
exports.createHifiLandingView = createHifiLandingView;
//# sourceMappingURL=createHifiLandingView.js.map